<template>
  <div>
    <div class="mailboxs-title">
      <div>{{ $t('configuration_management.mailbox_management.email') }}</div>
    </div>
    <template>
      <Tabs size="small" :animated="false">
        <TabPane :label="$t('configuration_management.mailbox_management.monitorMailboxConfiguration')">
          <div class="mailboxs-top">
            <mailboxs-search></mailboxs-search>
          </div>
          <table-mailboxs></table-mailboxs>
        </TabPane>
        <TabPane :label="$t('configuration_management.mailbox_management.emailSubjectKeyword')">
          <div class="mailboxs-top">
            <subject-keyword-search></subject-keyword-search>
          </div>
          <table-subject-keyword></table-subject-keyword>
        </TabPane>
        <TabPane :label="$t('configuration_management.mailbox_management.processEmails')">
          <div class="mailboxs-top">
            <subject-to-be-processed-search></subject-to-be-processed-search>
          </div>
          <table-subject-to-be-processed></table-subject-to-be-processed>
        </TabPane>
      </Tabs>
    </template>
  </div>
</template>
<script>
  import MailboxsSearch from "./MailboxsSearch";
  import TableMailboxs from "./TableMailboxs";
  import TableSubjectKeyword from "./TableSubjectKeyword";
  import SubjectKeywordSearch from "./SubjectKeywordSearch";
  import SubjectToBeProcessedSearch from "./SubjectToBeProcessedSearch";
  import TableSubjectToBeProcessed from "./TableSubjectToBeProcessed";

  export default {
    name: 'Mailboxs',
    components: {
      TableSubjectToBeProcessed,
      SubjectToBeProcessedSearch,
      SubjectKeywordSearch,
      TableSubjectKeyword,
      MailboxsSearch,
      TableMailboxs
    }
  }
</script>

<style scoped>
  .mailboxs-title {
    width: 100%;
    font-size: 13px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 15px 0px 8px 4px;
    font-weight: 600;
  }

  .mailboxs-top {
    width: 100%;
    height: 53px;
  }
</style>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/monitor_mailbox_configuration/Mailboxs.vue